import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pr-select-search',
    templateUrl: './pr-select-search.component.html',
    styleUrls: ['./pr-select-search.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrSelectSearchComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class PrSelectSearchComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() label: string = '';
  @Input() placeholder: string = 'Rechercher...';
  @Input() options: any[] = [];
  @Input() optionValueKey: string = 'id';
  @Input() optionDisplayKey: string = 'value';
  @Input() displayFn: (option: any) => string;

  @Output() selectionChange = new EventEmitter<any>();

  searchTerm: string = '';
  filteredOptions: any[] = [];
  value: any;

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() {}

  ngOnInit(): void {
    this.filteredOptions = this.options;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options && changes.options.currentValue) {
      this.filteredOptions = changes.options.currentValue;
    }
  }

  filter(searchTerm: string): void {
    console.log({ searchTerm });

    if (!searchTerm) {
      this.filteredOptions = this.options;
      return;
    }
    const filterValue = searchTerm.toLowerCase();
    this.filteredOptions = this.options.filter(option => {
      const text = this.getDisplayValue(option).toLowerCase();
      return text.includes(filterValue);
    });
  }

  getDisplayValue(option: any): string {
    if (this.displayFn) {
      return this.displayFn(option);
    }
    return option[this.optionDisplayKey];
  }

  onSelectionChange(selectedValue: any): void {
    this.value = selectedValue;
    this.onChange(selectedValue);
    this.onTouched();

    this.selectionChange.emit(selectedValue);

    setTimeout(() => {
      this.searchTerm = '';
      this.filter('');
    }, 200);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
